// extracted by mini-css-extract-plugin
export default {"root":"ImageLoader_root__-TIH+","spinner":"ImageLoader_spinner__AxdAs"};